import axios from 'axios'

interface APIErrorPayload {
  error?: { code?: string; message?: string }
}

export function extractErrorMessage(err: unknown): string {
  if (axios.isAxiosError<APIErrorPayload>(err)) {
    const apiMsg = err.response?.data?.error?.message
    if (apiMsg) return apiMsg
    if (err.message) return err.message
  }
  if (err instanceof Error) return err.message
  return String(err)
}
